const fontArr = [
    {name:'icon-fasongxiaoxi'},
    {name:'icon-xiaoxiyidu'},
    {name:'icon-xiaoxixiangqing'},
    {name:'icon-xiaoxiguanli'},
    {name:'icon-daorucaidan'},
    {name:'icon-qiangzhixiaxian'},
    {name:'icon-xiaoxipingtai'},
    {name:'icon-xiaoxifenlei'},
    {name:'icon-xiaoxidengji'},
    {name:'icon-xiaoxijieshou'},
    {name:'icon-liucheng'},
    {name:'icon-xitongguanli'},
    {name:'icon-yulan'},
    {name:'icon-download'},
    {name:'icon-jiaose'},
    {name:'icon-zidian'},
    {name:'icon-wendang'},
    {name:'icon-fenxiang'},
    {name:'icon-zhandian'},
    {name:'icon-shangchuan2'},
    {name:'icon-caidan'},
    {name:'icon-shenhe'},
    {name:'icon-jigou'},
    {name:'icon-caozuojilu'},
    {name:'icon-songshen'},
    {name:'icon-xinjianwenjianjia'},
    {name:'icon-mp'},
    {name:'icon-DOCX'},
    {name:'icon-XLSX'},
    {name:'icon-pptx'},
    {name:'icon-AVI'},
    {name:'icon-PPT'},
    {name:'icon-png'},
    {name:'icon-JPEG'},
    {name:'icon-Jpg'},
    {name:'icon-FLV'},
    {name:'icon-GIF'},
    {name:'icon-dwg'},
    {name:'icon-wmv'},
    {name:'icon-qiehuan'},
    {name:'icon-add'},
    {name:'icon-dustbin_icon'},
    {name:'icon-xiugai'},
    {name:'icon-chaxun'},
    {name:'icon-shangchuan'},
    {name:'icon-xinjianzu'},
    {name:'icon-daochu'},
    {name:'icon-jiesuo'},
    {name:'icon-xiangxi'},
    {name:'icon-touxiang'},
    {name:'icon-suoding'},
    {name:'icon-suoding1'},
    {name:'icon-bumen'},
    {name:'icon-phone'},
    {name:'icon-xiayi'},
    {name:'icon-shangyi'},
    {name:'icon-jiantoushang'},
    {name:'icon-jiantouxia'},
    {name:'icon-biaoqing'},
    {name:'icon-wenjiandai'},
    {name:'icon-biaoqian'},
    {name:'icon-dakai1'},
    {name:'icon-shaixuan'},
    {name:'icon-sanjiaoright'},
    {name:'icon-tuichu'},
    {name:'icon-icon-arrow-down'},
    {name:'icon-down-jiantou'},
    {name:'icon-question-circle'},
    {name:'icon-renyuan2'},
    {name:'icon-serviceshandiantuikuan'},
    {name:'icon-shigongrenyuan'},
    {name:'icon-kucunguanli'},
    {name:'icon-xiuli'},
    {name:'icon-chaoshi'},
    {name:'icon-lingdao'},
    {name:'icon-baojing'},
]
export default fontArr


// WEBPACK FOOTER //
// ./src/components/LrInput/font.js